import { useState } from 'react'
import { Button, Flex, Tabs } from 'antd'
import ImageWrapper from '@/components/image-wrapper'
import Styles from './style.module.scss'
import useLang from '@/utils/hooks/use-lang'
import { useNavigate } from 'react-router-dom'
import { i18nSolutionCustom } from '@/assets/content/solution'
import { productSolutionData } from './data'

const MASK = 'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%)'

export default function Content() {
  const [activeIndex, setActiveIndex] = useState(0)
  const navigate = useNavigate()
  const [lang] = useLang()
  const content = productSolutionData || []
  const solutionCover = content?.[activeIndex]?.banner
  const current = content[activeIndex]

  const tabData = content?.map((d, i) => ({
    key: i.toString(),
    label: d.title,
  }))

  return (
    <ImageWrapper mask={MASK} backgroundImage={solutionCover} className={Styles.container}>
      <Flex vertical align='center' className={Styles.main}>
        <Flex key={activeIndex} vertical className={Styles.content}>
          <h5 className={Styles.title}>{current.subTitle}</h5>
          {!!current?.description && <div className={Styles.description}>{current.description}</div>}
          {!!current?.path && (
            <Button type='primary' className={Styles.moreButton} onClick={() => navigate(current.path)}>
              More
            </Button>
          )}
        </Flex>
        <Tabs
          defaultActiveKey='1'
          items={tabData}
          className={Styles.tabBar}
          indicator={{ size: origin => origin + 56 }}
          onChange={key => setActiveIndex(key)}
        />
      </Flex>
    </ImageWrapper>
  )
}
